/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const DiceD6IconConfig = {
  name: 'DiceD6Icon',
  height: 512,
  width: 448,
  svgPath: 'M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(DiceD6IconConfig);
//# sourceMappingURL=dice-d6-icon.js.map